/**
* Licensed Materials - Property of IBM
* IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2018
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([
	'../../lib/@waca/dashboard-common/dist/core/Model'
],
function(Class) {
	'use strict';

	var DateTimeFilterModel = Class.extend({

		whitelistAttrs: ['name', 'from', 'to', 'min', 'max', 'rangeType', 'inverted'],

		init: function() {
			DateTimeFilterModel.inherited('init', this, arguments);
			this.name = this.name || '';
			this.inverted = Boolean(this.inverted) || false;
			this.from = this.from || '';
			this.to = this.to || '';
			this.min = this.min || '';
			this.max = this.max || '';
			this.rangeType = this.rangeType || 'between';
		},

		setName: function (name){
			this.name = name;
		},

		getName: function (){
			return this.name;
		},

		getInvert: function () {
			return this.inverted;
		},

		setInvert: function (trueOrFalse) {
			this.set({ inverted: trueOrFalse });
		},

		update: function(from, to, min, max, rangeType, inverted){
			this.set({ from: from,
				to: to,
				min: min,
				max: max,
				rangeType: rangeType,
				inverted: inverted });
		},

		clearValues: function(){
			this.set({
				from: this.min,
				to: this.max,
				rangeType: 'between',
				inverted: false
			});
		}
	});

	return DateTimeFilterModel;
});
